<template>
  <b-modal
    id="modal-face-inference" 
    size="sm" 
    centered
    hide-footer
    @hidden="resetModal"
    @show="onShow"
  >
    <template slot="modal-header">
      <div class="d-block text-center w-100">
        <Icon name="grFileSearch" :width="36" class="mb-3"/>
        <h1 class="modal-title mb-2">{{ $t('modal_face_inference.title') }}</h1>
        <h4 class="modal-subtitle px-1 pt-4">{{ $t('modal_face_inference.description') }}</h4>
      </div>
    </template>

    <div class="d-block">
      <div class="row">
        <div class="col-sm-6 order-sm-1 mb-2 mb-sm-0">
          <b-button 
            variant="primary" 
            size="md" 
            block
            @click="activateSearch"
            :disabled="loading"
          >
            <b-spinner small v-if="loading" class="mr-2"></b-spinner>
            {{ loading ? $t('modal_face_inference.btn_loading') : $t('modal_face_inference.btn_activate') }}
          </b-button>
        </div>
        <div class="col-sm-6 order-sm-0">
          <b-button 
            variant="light" 
            size="md" 
            block
            @click="$bvModal.hide('modal-face-inference')"
            :disabled="loading"
          >
            {{ $t('modal_face_inference.btn_later') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import EventService from "@/services/Event.js"

export default {
  name: 'ModalFaceInference',
  
  props: {
    checkinId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    onShow() {
      this.loading = false
    },

    resetModal() {
      this.loading = false
    },

    async activateSearch() {
      this.loading = true
      
      try {
        const response = await EventService.startFaceInference(this.checkinId)
        if (response.data && response.data.success === true) {
          this.$emit('face-inference-started')
          this.$bvModal.hide('modal-face-inference')
          this.$bvToast.toast(this.$t('modal_face_inference.success_message'), {
            title: this.$t('modal_face_inference.success_title'),
            variant: 'success',
            autoHideDelay: 5000
          })
        } else {
          console.error('Face inference failed:', response.data)
          const errorMessage = this.$t('modal_face_inference.error_message')
          this.$bvToast.toast(errorMessage, {
            title: this.$t('modal_face_inference.error_title'),
            variant: 'danger',
            autoHideDelay: 5000
          })
        }
      } catch (error) {
        console.error('Face inference error:', error)
        
        // Show error toast
        this.$bvToast.toast(this.$t('modal_face_inference.error_message'), {
          title: this.$t('modal_face_inference.error_title'),
          variant: 'danger',
          autoHideDelay: 5000
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>